import { render } from "./CarDefectsLists.vue?vue&type=template&id=050ea951"
import script from "./CarDefectsLists.vue?vue&type=script&lang=js"
export * from "./CarDefectsLists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__